import { parseQuery } from './parseQuery';
import { gameLiveConnection } from '../services';
import { DefaultQueryParams } from '../constants/defaultQueryParams';

export const handleCollect = () => {
  const { [DefaultQueryParams.GameId]: gameId } = parseQuery(window.location.search);
  return gameLiveConnection.sendSpinCollect(gameId);
};
